import Vue from 'vue';

import { buildFetchMutations } from '@/store/extensions/fetch';
import { buildCreateMutations } from '@/store/extensions/create';
import { buildUpdateMutations } from '@/store/extensions/update';
import { buildDeleteMutations } from '@/store/extensions/delete';

export default {
  ...buildFetchMutations(['fetchSchedules', 'fetchSchedule']),
  ...buildCreateMutations(['createSchedule']),
  ...buildUpdateMutations(['updateSchedule']),
  ...buildDeleteMutations(['deleteSchedule']),

  setContext: (state, payload = null) => {
    Vue.set(state, 'context', payload);
  },

  openFormModal: (state, payload = null) => {
    Vue.set(state, 'formModalOpened', true);
    Vue.set(state, 'formModalAdditionalContext', payload);
  },

  closeFormModal: (state) => {
    Vue.set(state, 'formModalOpened', false);
    Vue.set(state, 'formModalAdditionalContext', null);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/schedule/mutations.js